var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-menu"},_vm._l((_vm.menus),function(menu,i){return _c('div',{key:menu.url + i,staticClass:"menu",class:{ active: menu.url === _vm.activeName },on:{"click":function($event){return _vm.clickMenu(menu)}}},[_vm._v(" "+_vm._s(menu.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }